import Vue from 'vue'
import Router from 'vue-router'

import { ModuleId } from '../const'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Page
const PageRouter = () => import('@/page-lib/components/PageRouter')

Vue.use(Router)

export default new Router({
  mode: process.env.VUE_APP_VUE_ROUTER_MODE, // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [],
})

export function configRoutes (i18nMessage, loggedInUser) {

  const routes = {}

  // Image
  const Image = () => import('@/views/image/Image')

  routes[ModuleId.Image] = [
    {
      path: 'image',
      meta: {
        label: i18nMessage.Image,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.Images,
          },
          name: 'Image',
          component: Image,
          props: { 
            enabledDelete: true,
          },
        },
      ]
    },
  ]

  const BoMembers = () => import('@/views/bo-member/BoMembers')
  const BoMember = () => import('@/views/bo-member/BoMember')

  routes[ModuleId.BoMember] = [
    {
      path: 'bo-member',
      meta: {
        label: i18nMessage.BoMember,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.BoMembers,
          },
          name: 'BoMembers',
          component: BoMembers,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewBoMember,
          },
          name: 'New BoMember',
          component: BoMember,
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.BoMemberDetail,
          },
          name: 'BoMember Detail',
          component: BoMember,
        },
      ],
    },
  ]



  const Members = () => import('@/views/member/Members')
  const Member = () => import('@/views/member/Member')

  routes[ModuleId.Member] = [
    {
      path: 'member',
      meta: {
        label: i18nMessage.Member
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.Members,
          },
          name: 'Members',
          component: Members,
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.MemberDetail,
          },
          name: 'Member Detail',
          component: Member,
        },
      ],
    },
  ]

  // Page Builder
  const GlobalStyle = () => import('@/views/page-builder/GlobalStyle')
  const GlobalStyles = () => import('@/views/page-builder/GlobalStyles')
  const PageBuilders = () => import('@/views/page-builder/PageBuilders')
  const PageBuilder = () => import('@/views/page-builder/PageBuilder')
  const SectionBuilder = () => import('@/views/page-builder/SectionBuilder')
  const SectionBuilders = () => import('@/views/page-builder/SectionBuilders')
  const IframePageRender = () => import('@/components/IframePageRender')

  routes[ModuleId.PageBuilder] = [
    {
      path: 'global-style',
      meta: {
        label: i18nMessage.GlobalStyle,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.GlobalStyles,
          },
          name: 'Global Styles',
          component: GlobalStyles,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewStyle
          },
          name: 'New Style',
          component: GlobalStyle,
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.StyleDetail
          },
          name: 'Style Detail',
          component: GlobalStyle,
        },
      ]
    },
    {
      path: 'page-builder',
      meta: {
        label: i18nMessage.Page
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.PageBuilders,
          },
          name: 'Page Builders',
          component: PageBuilders,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewPage,
          },
          name: 'New Page',
          component: PageBuilder
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.PageDetail,
          },
          name: 'Page Detail',
          component: PageBuilder
        },
      ]
    },
    {
      path: 'section-builder',
      meta: {
        label: i18nMessage.SectionBuilder,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.SectionBuilders,
          },
          name: 'Section Builders',
          component: SectionBuilders,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewSection,
          },
          name: 'New Section',
          component: SectionBuilder
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.SectionDetail,
          },
          name: 'Section Detail',
          component: SectionBuilder
        },
      ]
    },
  ]

  const SectionBuilderEditors = () => import('@/views/page-builder/SectionBuilderEditors')
  const SectionBuilderEditor = () => import('@/views/page-builder/SectionBuilderEditor')
  routes[ModuleId.PageBuilderEditor] = [
    {
      path: 'section-builder-editor',
      meta: {
        label: i18nMessage.SectionEditor,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.SectionBuilders,
          },
          name: 'Section Editors',
          component: SectionBuilderEditors,
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.SectionDetail,
          },
          name: 'Section Detail',
          component: SectionBuilderEditor
        },
      ]
    },
  ]


  // Email Builder
  const EmailBuilder = () => import('@/views/email/EmailBuilder')
  const EmailBuilders = () => import('@/views/email/EmailBuilders')

  routes[ModuleId.EmailBuilder] = [
    {
      path: 'email-builder',
      meta: {
        label: i18nMessage.EmailBuilder,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.EmailBuilders,
          },
          name: 'Email Builders',
          component: EmailBuilders,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewEmail,
          },
          name: 'New Email',
          component: EmailBuilder
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.EmailDetail,
          },
          name: 'Email Detail',
          component: EmailBuilder
        },
      ]
    },
  ]

  // Course
  const CourseTeachers = () => import('@/views/course/CourseTeachers')
  const CourseTeacher = () => import('@/views/course/CourseTeacher')
  const CourseCategories = () => import('@/views/course/CourseCategories')
  const CourseCategory = () => import('@/views/course/CourseCategory')
  const Courses = () => import('@/views/course/Courses')
  const Course = () => import('@/views/course/Course')

  routes[ModuleId.Course] = [
    {
      path: 'course-teacher',
      meta: {
        label: i18nMessage.CourseTeacher,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.CourseTeachers,
          },
          name: 'Course Teachers',
          component: CourseTeachers,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewCourseTeacher,
          },
          name: 'New Course Teacher',
          component: CourseTeacher
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.CourseTeacherDetail,
          },
          name: 'Course Teacher Detail',
          component: CourseTeacher
        },
      ]
    },
    {
      path: 'course-category',
      meta: {
        label: i18nMessage.CourseCategory,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.CourseCategories,
          },
          name: 'Course Categories',
          component: CourseCategories,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewCourseCategory,
          },
          name: 'New Course Category',
          component: CourseCategory
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.CourseCategoryDetail,
          },
          name: 'Course Category Detail',
          component: CourseCategory
        },
      ]
    },
    {
      path: 'course',
      meta: {
        label: i18nMessage.Course,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.Courses,
          },
          name: 'Courses',
          component: Courses,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewCourse,
          },
          name: 'New Course',
          component: Course
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.CourseDetail,
          },
          name: 'Course Detail',
          component: Course
        },
      ]
    },
  ]

  // Course Order
  const CourseOrders = () => import('@/views/course/CourseOrders')
  const CourseOrder = () => import('@/views/course/CourseOrder')
  const CourseCalendar = () => import('@/views/course/CourseCalendar')

  routes[ModuleId.CourseOrder] = [
    {
      path: 'course-order',
      meta: {
        label: i18nMessage.CourseOrder,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.CourseOrders,
          },
          name: 'Course Orders',
          component: CourseOrders,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewCourseOrder,
          },
          name: 'New Course Order',
          component: CourseOrder
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.CourseOrderDetail,
          },
          name: 'Course Order Detail',
          component: CourseOrder
        },
      ]
    },
    {
      path: 'course-calendar',
      meta: {
        label: i18nMessage.CourseCalendar,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.CourseCalendar,
          },
          name: 'Course Calendar',
          component: CourseCalendar,
        },
      ]
    },
  ]

  // Product
  const ProductCategories = () => import('@/views/product/ProductCategories')
  const ProductCategory = () => import('@/views/product/ProductCategory')
  const Products = () => import('@/views/product/Products')
  const Product = () => import('@/views/product/Product')
  const ProductShippings = () => import('@/views/product/ProductShippings')
  const ProductShipping = () => import('@/views/product/ProductShipping')
  const ProductCoupons = () => import('@/views/product/ProductCoupons')
  const ProductCoupon = () => import('@/views/product/ProductCoupon')

  routes[ModuleId.Product] = [
    {
      path: 'product-category',
      meta: {
        label: i18nMessage.ProductCategory,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.ProductCategories,
          },
          name: 'Product Categories',
          component: ProductCategories,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewProductCategory,
          },
          name: 'New Product Category',
          component: ProductCategory
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.ProductCategoryDetail,
          },
          name: 'Product Category Detail',
          component: ProductCategory
        },
      ]
    },
    {
      path: 'product',
      meta: {
        label: i18nMessage.Product,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.Products,
          },
          name: 'products',
          component: Products,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewProduct,
          },
          name: 'New Product',
          component: Product
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.ProductDetail,
          },
          name: 'Product Detail',
          component: Product
        },
      ]
    },
    {
      path: 'product-shipping',
      meta: {
        label: i18nMessage.ProductShipping,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.ProductShippings,
          },
          name: 'product Shippings',
          component: ProductShippings,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewProductShipping,
          },
          name: 'New Product Shipping',
          component: ProductShipping
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.ProductShippingDetail,
          },
          name: 'Product Shipping Detail',
          component: ProductShipping
        },
      ]
    },
    {
      path: 'product-coupon',
      meta: {
        label: i18nMessage.ProductCoupon,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.ProductCoupons,
          },
          name: 'product Coupons',
          component: ProductCoupons,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewProductCoupon,
          },
          name: 'New Product Coupon',
          component: ProductCoupon
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.ProductCouponDetail,
          },
          name: 'Product Coupon Detail',
          component: ProductCoupon
        },
      ]
    },
  ]

  // Product Order
  const ProductOrders = () => import('@/views/product/ProductOrders')
  const ProductOrder = () => import('@/views/product/ProductOrder')

  routes[ModuleId.ProductOrder] = [
    {
      path: 'product-order',
      meta: {
        label: i18nMessage.ProductOrder,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.ProductOrders,
          },
          name: 'product orders',
          component: ProductOrders,
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.ProductOrderDetail,
          },
          name: 'Product Order Detail',
          component: ProductOrder,
        },
      ]
    },
  ]

  // Blog
  const BlogCategories = () => import('@/views/blog/BlogCategories')
  const BlogCategory = () => import('@/views/blog/BlogCategory')
  const Blogs = () => import('@/views/blog/Blogs')
  const Blog = () => import('@/views/blog/Blog')

  routes[ModuleId.Blog] = [
    {
      path: 'blog-category',
      meta: {
        label: i18nMessage.BlogCategory,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.BlogCategories,
          },
          name: 'Blog Categories',
          component: BlogCategories,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewBlogCategory,
          },
          name: 'New Blog Category',
          component: BlogCategory
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.BlogCategoryDetail,
          },
          name: 'Blog Category Detail',
          component: BlogCategory
        },
      ]
    },
    {
      path: 'blog',
      meta: {
        label: i18nMessage.Blog,
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {
            label: i18nMessage.Blogs,
          },
          name: 'Blogs',
          component: Blogs,
        },
        {
          path: 'new',
          meta: {
            label: i18nMessage.NewBlog,
          },
          name: 'New Blog',
          component: Blog
        },
        {
          path: ':id',
          meta: {
            label: i18nMessage.BlogDetail,
          },
          name: 'Blog Detail',
          component: Blog
        },
      ]
    },
  ]

  const finalRoutes = [
    {
      path: '/imageManager',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          name: 'ImageManager',
          component: Image,
          props: { 
            enabledApply: true,
          },
        },
      ]
    },
    {
      path: '/iframe-page-render',
      meta: {},
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          meta: {},
          name: 'IframePageRender',
          component: IframePageRender,
        },
      ]
    },
    {
      path: '/page-preview',
      name: 'PageRouterRoot',
      component: PageRouter,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]

  const homeRoute = {
    path: '/',
    redirect: '/dashboard',
    meta: {
      label: i18nMessage.Home,
    },
    name: 'Home',
    component: TheContainer,
    children: [
      {
        path: 'dashboard',
        meta: {
          label: i18nMessage.Dashboard,
        },
        name: 'Dashboard',
        component: Dashboard
      },  
    ]
  }

  if (loggedInUser) {
    if (loggedInUser.modules && loggedInUser.modules.length > 0) {
      loggedInUser.modules.forEach(module => {
        if (module in routes) {
          const subRoutes = routes[module]
          for (const subroute of subRoutes) {
            homeRoute.children.push(subroute)
          }
        }
      })
    } else {
      Object.keys(routes).forEach(module => {
        const subRoutes = routes[module]
        for (const subroute of subRoutes) {
          homeRoute.children.push(subroute)
        }
      })
    }
  }

  finalRoutes.push(homeRoute)

  return finalRoutes
}

